import { PARENT_SIGNUP_ENABLED } from '../config/agePolicy';
import { UserProfile } from '../types';
import { UserRole } from '../types/database';

/**
 * Check if a user is authorized to access the coach portal
 * During closed beta, only coaches are allowed
 */
export const isCoachAuthorized = (profile: UserProfile | null): boolean => {
  if (!profile) return false;

  // During closed beta, only coaches are allowed
  return profile.user_role === UserRole.Coach;
};

/**
 * Check if a role is allowed to sign up during closed beta.
 * Accepts any role string so callers (e.g. from API or tests) can pass unknown roles and get false.
 */
export const isRoleAllowedForSignup = (role: string): boolean => {
  if (role === 'coach' || role === 'rower') return true;
  if (role === 'parent' && PARENT_SIGNUP_ENABLED) return true;
  return false;
};

/**
 * Get appropriate error message for unauthorized access
 */
export const getUnauthorizedMessage = (context: 'signin' | 'signup'): string => {
  if (context === 'signup') {
    return "GLYYD is currently invite-only for coaches during our beta phase. We'll be opening to athletes and families soon.";
  }

  return 'Access to the coach portal is currently limited to invited coaches during our beta phase.';
};
